import { TradingSystem } from '@monorepo/types';
import { DesignIconNames } from './lib/design-icons';

export const tradingSystemsIcons: Record<TradingSystem, DesignIconNames> = {
  [TradingSystem.MetaTraderFive]: 'MetaTraderFive',
  [TradingSystem.CTrader]: 'CTrader',
  [TradingSystem.TraderEvolution]: 'TraderEvolution',
  [TradingSystem.MatchTrader]: 'CTrader',
  [TradingSystem.MetaTraderXP]: 'MetaTraderFive',
  [TradingSystem.MetaTraderContest]: 'MetaTraderFive',
  [TradingSystem.BlackArrowFutures]: 'The5ersLogoShort',
};
